module.exports = __webpack_public_path__ + "img/scene2.724c8e51.png";